export default "/static/webpack/images/home/invoice.svg";